import routes from "./routes";
import { useHistory } from "react-router";
import React, { useCallback } from "react";
import { Icon, Menu } from "antd";
import { Icon as BP3Icon } from "@blueprintjs/core";

export const leftNavMenuItems = [
  {
    urlPath: routes.opportunities,
    title: "Opportunities",
    iconType: "dashboard",
    appModes: ["dvy", "xca"],
    itinModes: ["oneway", "roundtrip"],
  },
  {
    urlPath: routes.bookings,
    title: "Past Bookings",
    iconType: "book",
    appModes: ["dvy", "xca"],
    itinModes: ["oneway", "roundtrip"],
  },
  {
    urlPath: routes.suspends,
    title: "Past Suspends",
    bp3IconType: "pause",
    appModes: ["dvy", "xca"],
    itinModes: ["oneway", "roundtrip"],
  },
  {
    urlPath: routes.skippings,
    title: "Past Skipped",
    iconType: "fast-forward",
    appModes: ["dvy", "xca"],
    itinModes: ["oneway", "roundtrip"],
  },
  {
    // TODO: xca-oneway, xca-roundtrip
    urlPath: routes.planner_stats,
    title: "Planner Stats",
    bp3IconType: "grid",
    appModes: ["dvy"],
    itinModes: ["oneway"],
  },
  {
    // TODO: xca-oneway, xca-roundtrip
    urlPath: routes.platform_stats,
    title: "Platform Stats",
    bp3IconType: "chart",
    appModes: ["dvy"],
    itinModes: ["oneway"],
  },
  {
    // TODO: xca-oneway, xca-roundtrip
    urlPath: routes.dead_opps,
    title: "Hidden Opportunities",
    bp3IconType: "eye-off",
    appModes: ["dvy"],
    itinModes: ["oneway"],
  },
];

export function LeftNavMenuItem({
  urlPath,
  title,
  iconType,
  bp3IconType,
  history,
}) {
  return (
    <Menu.Item
      key={urlPath || iconType || bp3IconType}
      title={title}
      onClick={() => urlPath && history.push(urlPath)}
      data-testid={`leftnav-${urlPath}`}
    >
      {iconType ? <Icon type={iconType} /> : <BP3Icon icon={bp3IconType} />}
    </Menu.Item>
  );
}
